import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Joins conditional class names and lets later Tailwind classes override earlier conflicting ones. */
export function cn(...classValues: ClassValue[]): string {
  return twMerge(clsx(classValues))
}
